import { mapState,mapActions } from 'vuex'
import menuMixin from '../mixin/menu'
import { elMenuItem, elSubmenu } from '../libs/util.menu'
import BScroll from 'better-scroll'
export default {
  name: 'd2-layout-header-aside-menu-side',
  mixins: [menuMixin],
  render(createElement) {
    if(!this.showFlag){
      return createElement(
        'div',
        { attrs: { class: 'd2-layout-header-aside-menu-side' }},
        [
          createElement(
            'el-menu',
            {
              props: {
                collapse: this.asideCollapse,
                uniqueOpened: true,
                defaultActive: this.active
              },
              ref: 'menu',
              on: { select: this.handleMenuSelect }
            },
            null
          ),
          ...([])
        ]
      )
    }else{
      return createElement(
        'div',
        { attrs: { class: 'd2-layout-header-aside-menu-side' }},
        [
          createElement(
            'el-menu',
            {
              props: {
                collapse: this.asideCollapse,
                uniqueOpened: true,
                defaultActive: this.active
              },
              ref: 'menu',
              on: { select: this.handleMenuSelect }
            },
            this.aside.map(menu =>
            // this.menuAside.map(menu =>
              (menu.children === undefined ||
              menu.children === null ||
              menu.children.length == 0
                ? elMenuItem
                : elSubmenu
              ).call(this, createElement, menu,this.account)
            )
          ),
          ...(this.aside.length === 0 && !this.asideCollapse
          // ...(this.menuAside.length === 0 && !this.asideCollapse
            ? [
              // createElement(
              //   'div',
              //   {
              //     attrs: {
              //       class: 'd2-layout-header-aside-menu-empty',
              //       flex: 'dir:top main:center cross:center'
              //     }
              //   },
              //   [
              //     createElement('d2-icon', { props: { name: 'inbox' }}),
              //     createElement('span', {}, '没有侧栏菜单')
              //   ]
              // )
            ]
            : [])
        ]
      )
    }
  },
  data() {
    return {
      showFlag:true,
      active: '',
      asideHeight: 300,
      menuAside: [],
      openeds: [],
      matched: null,
      BS: null
    }
  },
  computed: {
    ...mapState('d2admin/finance', ['account']),
    ...mapState('d2admin/menu', ['aside', 'asideCollapse'])
  },
  watch: {
    // 折叠和展开菜单的时候销毁 better scroll
    asideCollapse(val) {
      this.scrollDestroy()
      setTimeout(() => {
        this.scrollInit()
      }, 500)
    },
    // 监听路由 控制侧边栏激活状态
    '$route.fullPath': {
      handler(value) {
        this.active = value
      },
      immediate: true
    },
    aside:{
      handler(value) {
       if(!value||value.length<1){
        this.showFlag=false
        this.getAside()
        this.$nextTick(()=>{
          this.showFlag=true
        })
      }
      },
      immediate: true
    }
  // },
  },

  //   // 监听路由 控制侧边栏激活状态
  //   $route: {
  //     handler({ matched, fullPath }) {
  //       // 路由父级发生变化时菜单数据将发生改变
  //       const pathRoute = matched[0].path ? matched[0].path : matched[1].path
  //       if (matched.length > 0 && pathRoute !== this.matched) {
  //         const _side = this.aside.find(menu => menu.path === pathRoute)
  //         this.menuAside = _side && _side.children ? _side.children : []
  //         this.matched = pathRoute
  //       }

  //       // 切换菜单时调整被激活菜单
  //       const path = fullPath.slice(0, fullPath.lastIndexOf('/'))
  //       const openeds = this.menuAside.findIndex(menu => menu.path === path)
  //       this.openeds = openeds !== -1 ? [path] : []

  //       this.active = fullPath
  //       this.$nextTick(() => {
  //         if (this.aside.length > 0 && this.$refs.menu) {
  //           this.$refs.menu.activeIndex = fullPath
  //         }
  //       })
  //     },
  //     immediate: true
  //   }
  // },
  mounted() {
    this.scrollInit()
  },
  beforeDestroy() {
    this.scrollDestroy()
  },
  methods: {
    ...mapActions('d2admin/menu', [
      'getAside',
    ]),
    scrollInit() {
      this.BS = new BScroll(this.$el, {
        mouseWheel: true,
        click: true,
        // 如果你愿意可以打开显示滚动条
        // scrollbar: {
        //   fade: true,
        //   interactive: false
        // }
      })
    },
    scrollDestroy() {
      // https://github.com/d2-projects/d2-admin/issues/75
      try {
        this.BS.destroy()
      } catch (e) {
        delete this.BS
        this.BS = null
      }
    }
  }
}
